import { __assign } from '../../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import { useFormContext, useController } from 'react-hook-form';
import { FormLabel, FormHint } from '../Form.styles.js';
import { RadioInputContainer } from './RadioInput.styles.js';
import RadioInputItem from './RadioInputItem.js';

var RadioInput = function (_a) {
    var name = _a.name, label = _a.label, options = _a.options, _b = _a.showError, showError = _b === void 0 ? true : _b, children = _a.children;
    var setValue = useFormContext().setValue;
    var _c = useController({ name: name }), field = _c.field, fieldState = _c.fieldState;
    var childrenDecoratedWithName = React.useMemo(function () { return traverseChildrenAndAddNameProp(children, name); }, [children, name]);
    return (React.createElement(RadioInputContainer
    // We want to use this with radix so we need to set the value manually
    // @ts-expect-error but it doesn't know the type of the provided schema throwing the a type error
    , __assign({ 
        // We want to use this with radix so we need to set the value manually
        // @ts-expect-error but it doesn't know the type of the provided schema throwing the a type error
        onValueChange: function (value) { return setValue(name, value); }, "aria-label": name }, field),
        label && React.createElement(FormLabel, null, label), options === null || options === void 0 ? void 0 :
        options.map(function (_a) {
            var value = _a.value, label = _a.label, disabled = _a.disabled;
            return (React.createElement(RadioInputItem, { key: value, name: name, value: value, label: label, disabled: disabled }));
        }),
        childrenDecoratedWithName,
        fieldState.error && showError && (React.createElement(FormHint, { error: true }, fieldState.error.message))));
};
RadioInput.Item = RadioInputItem;
var traverseChildrenAndAddNameProp = function (node, name) {
    return React.Children.toArray(node).map(function (child) {
        if (!child.type) {
            return child;
        }
        if (child.type.name === RadioInputItem.name) {
            return React.cloneElement(child, {
                name: name,
            });
        }
        else {
            return React.cloneElement(child, undefined, child.props.children
                ? traverseChildrenAndAddNameProp(child.props.children, name)
                : undefined);
        }
    });
};

export { RadioInput };
//# sourceMappingURL=RadioInput.js.map
